import script from "./Navbar.vue?vue&type=script&lang=ts&setup=true"
export * from "./Navbar.vue?vue&type=script&lang=ts&setup=true"

import "./Navbar.vue?vue&type=style&index=0&id=3c9f424e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1008117636/src/bitbucket.org/labtravelfactory/booking-funnel-xftless/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c9f424e"]])

export default __exports__